import styled from 'styled-components'

export const InputRow = styled.div`
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`
export const RangeNumbers = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: 10px;
`

export const CalculatorStepContainer = styled.div`
  display: flex;
  width: ${(props) => (props.width ? props.width : '50%')};
  flex-direction: column;
`

export const ActivityBox = styled.div`
  margin-top: ${(props) => (props.marginTop ? props.marginTop : '7%')};
  border-radius: 19px;
  /* background-image: linear-gradient(to right, #728ffc, #ea96b0); */
  background-color: rgba(255, 255, 255, 0.2);
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  padding: 5%;
  box-sizing: border-box;
  box-shadow: 0.7px 2.8px 2px rgba(0, 0, 0, 0.006),
    1.7px 6.7px 4.9px rgba(0, 0, 0, 0.008),
    3.1px 12.5px 9.1px rgba(0, 0, 0, 0.01),
    5.6px 22.3px 16.3px rgba(0, 0, 0, 0.012),
    10.4px 41.8px 30.5px rgba(0, 0, 0, 0.014),
    25px 100px 73px rgba(0, 0, 0, 0.02);
`

export const UserGoalButtonBox = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px;
  background-color: #342152;
  border-radius: 25px;
  height: 50px;
  box-sizing: border-box;

  @media only screen and (max-width: 1400px) {
    height: 30px;
    border-radius: 20px;
    padding: 2px;
  }

  @media only screen and (max-width: 600px) {
    height: 40px;
  }

  &.progress-option {
    width: 40%;
    margin-top: 3%;

    @media only screen and (max-width: 600px) {
      margin-top: 1%;
    }

    @media only screen and (max-width: 600px) {
      width: 85%;
    }
  }
`

export const UserGoalOption = styled.div`
  width: 33%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 19px;
  text-align: center;
  font-family: 'Nunito';
  background-color: #342152;
  height: 100%;
  color: #ffffff;
  cursor: pointer;

  &:hover {
    background-color: #a1ff68;
    color: #342152;
  }

  &.active {
    background-color: #a1ff68;
    color: #342152;
  }
`

export const ResultColumn = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`
